export const IMAGES = {
  Arrow: require('./morphis/morphis-blue-up-arrow-volumetric.png'),
  Brain: require('./morphis/morphis-neural-network-brain.png'),
  Cover: require('./cover.png'),
  Emoji: require('./Emoji.png'),
};
